export class MobileDetectHelper {
  static isTablet() {
    const w = window.innerWidth;

    return w < 1200 && w >= 768;
  }
}
